
import { 
  collection, 
  doc, 
  getDoc, 
  addDoc,
  updateDoc,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "./config";

export const getFamilyById = async (familyId: string) => {
  try {
    const familyDoc = await getDoc(doc(db, "families", familyId));
    if (familyDoc.exists()) {
      return { id: familyDoc.id, ...familyDoc.data() };
    }
    return null;
  } catch (error) {
    console.error("Error getting family: ", error);
    throw error;
  }
};

export const updateFamilyDetails = async (
  familyId: string,
  name: string,
  description: string,
  icon: string
) => {
  try {
    await updateDoc(doc(db, "families", familyId), {
      name,
      description,
      icon,
      updatedAt: serverTimestamp()
    });
    
    return true;
  } catch (error) {
    console.error("Error updating family: ", error);
    throw error;
  }
};

export const createFamily = async (
  name: string,
  description: string,
  icon: string,
  userId: string,
  email: string,
  firstName: string,
  lastName: string,
  image: string
) => {
  try {
    // First create the family
    const familyRef = await addDoc(collection(db, "families"), {
      name,
      description,
      icon,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    // Then create the parent user with auth ID as both document ID and id field
    await setDoc(doc(db, "users", userId), {
      id: userId,  // Store the Firebase auth ID as the id field
      familyId: familyRef.id,
      firstName,
      lastName,
      username: email,
      image,
      role: "parent",
      balance: 0,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    return familyRef.id;
  } catch (error) {
    console.error("Error creating family: ", error);
    throw error;
  }
};
